<template>
    <div class="qclist">
        <div class="clearfix qcnav">
            <!-- <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="22" align="center" justify="center" style="font-size:19px;">维修项目</van-col>
            </row> -->
            <NavBar
                class="restclass"
                title="详情"
                left-text="返回"
                left-arrow
                @click-left="getBack"/>
        </div>
        <div class="container">
        <div class="Uploader">
              <div class="image">整车照片</div>
            <div class="imgAdd">
               <span  class="itemImg" v-for="(item,index) in fileList " :key="index" >
                 <img :src="item.url" alt="图片" class="uploadimg">
                 <!-- <img src="./image/del.png" alt="" @click="delImg(index)" class="delte"> -->
                 <!-- <img src="./image/del.png" alt="" class="delte"> -->
               </span>
               <div class="fileupload-box" v-show="this.fileList.length<=5">
                    <!-- <div class="c" @click='clicktotakephotose'> -->
                    <div class="c">
                        <!-- <input type="file"  style="display:none" id="uploadfile"  @change="fileChange($event)" accept="image/*" multiple/> -->
                        <img src="./image/1.png" id="image">
                    </div>

                </div>
              </div>
          </div>
  </div>
        <div style="padding:0 10px;">
            <row :gutter="20">
                <van-col span="24">
                    <!-- <van-button round block type="info" class="nextSpan" @click="allCarPhoto()">保存</van-button> -->
                </van-col>
                <!-- <van-col span="12">
                    <van-button round block type="info" class="nextSpan"
                        @click="submitandhandle">提交并处理</van-button>
                </van-col> -->
            </row>
        </div>
        <bottom />
    </div>
</template>

<script>

import { Icon, List, Button, Col, Row, Search, DropdownMenu, DropdownItem, PullRefresh, NavBar, Toast } from 'vant'
import bottom from '@/components/bottom'
import { getWorkOrderitemList } from '@/api/maintain'
import { getcategory } from '@/api/basics'

export default {
    name: 'Partsrepair',
    components: {
        bottom,
        Icon, List, [Button.name]: Button, [Col.name]: Col, Row, Search, DropdownMenu, DropdownItem, PullRefresh, NavBar
    },
    data() {
        return {
          vehiclePicture:'',
          id:'',
          fileList: [],
          images:[],
        }
    },
    mounted(){
      window['clicktotakephotos'] = data => {
          this.clicktotakephotos(data)
      }
      if(this.$route.query.photos){
        this.vehiclePicture=this.$route.query.photos
      }
    },
    created() {
      this.id = this.$route.query.id
      console.log(this.$route.query)
        if (this.$route.query.photos) {
            this.fileList = []
            // const picture = res.data.entranceUrl.split(';')
            var picture = this.$route.query.photos.split(';').filter(function(s) {
              return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
            })
            console.log(picture)
            picture.forEach(item => {
              this.fileList.push({
                url: item
              })
            })
          }
    },
    methods: {
      allCarPhoto(){
           this.$router.replace({
              path: '/QualityCheckDetail',
              query: { id:this.id,photos:this.vehiclePicture}
          })
      },
      getBack() {
          this.$router.push({ path: '/StatementDetailfac' ,query: { id:this.id,photos:this.vehiclePicture }})
      },
      // 点击删除
      // delImg(index) {
        
      //   this.vehiclePicture = ''
      //   if (isNaN(index) || index >= this.fileList.length) {
      //     return false;
      //   }
      //   this.fileList.splice(index, 1);
      //   if(this.fileList.length>0){
      //       this.fileList.forEach(item=>{
      //         this.vehiclePicture = this.vehiclePicture.concat(item.url + ';')
      //       })
      //     }
      //   },
        // 点击的时候调用相机
        clicktotakephotos(val) {
          
            const obj = {
                url:process.env.VUE_APP_IMG+val
            }
            this.fileList.push(obj)
            // const vals = val
            // this.vals = val
            // vals='file:///'+val
            // this.images.push(vals)
            this.vehiclePicture = this.vehiclePicture.concat(process.env.VUE_APP_IMG + val+';')
          
            
        },
        // clicktotakephotose() {
        //     window.test.openCamera('我是水印')
        // },
    }
}
</script>
<style>
.restclass .van-nav-bar{
    height: 1rem!important;
    background: #3982cc!important
}
</style>
<style lang='scss' scoped>

.qclist{
    width: 100%;
  .clientList{
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:8px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }
}
.info-span-top{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:45%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-bottom{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:46%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>

<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}

</style>

